import { render, staticRenderFns } from "./NewBrandSelect.vue?vue&type=template&id=d9ea0170&"
import script from "./NewBrandSelect.vue?vue&type=script&lang=js&"
export * from "./NewBrandSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports